/**
 * @typedef CityItem
 * @property {number} id
 * @property {string} name
 * @property {number} lat
 * @property {number} lon
 * @property {number} zoom
 * @property {number} area
 */

/** @type {Readonly<CityItem[]>} */
const cities = [
  { id: 1, name: 'Москва', lat: 55.753215, lon: 37.622504, zoom: 11, area: 2561500000 },
  { id: 2, name: 'Санкт-Петербург', lat: 59.938951, lon: 30.315635, zoom: 13, area: 1439000000 },
  { id: 3, name: 'Воронеж', lat: 51.660781, lon: 39.200269, zoom: 13, area: 596510000 },
  { id: 4, name: 'Волгоград', lat: 48.707067, lon: 44.516948, zoom: 13, area: 859400000 },
  { id: 5, name: 'Екатеринбург', lat: 56.838011, lon: 60.597465, zoom: 13, area: 859400000 },
  { id: 6, name: 'Казань', lat: 55.796289, lon: 49.108795, zoom: 13, area: 468000000 },
  { id: 7, name: 'Краснодар', lat: 45.03547, lon: 38.975313, zoom: 13, area: 339300000 },
  { id: 8, name: 'Красноярск', lat: 56.010563, lon: 92.852572, zoom: 13, area: 348000000 },
  { id: 9, name: 'Нижний Новгород', lat: 56.326797, lon: 44.006516, zoom: 13, area: 460000000 },
  { id: 10, name: 'Новосибирск', lat: 55.030199, lon: 82.92043, zoom: 13, area: 502700000 },
  { id: 11, name: 'Омск', lat: 54.989342, lon: 73.368212, zoom: 13, area: 573000000 },
  { id: 12, name: 'Пермь', lat: 58.01045, lon: 56.229434, zoom: 13, area: 803000000 },
  { id: 13, name: 'Ростов-на-Дону', lat: 47.222078, lon: 39.720349, zoom: 13, area: 354000000 },
  { id: 14, name: 'Самара', lat: 53.22194, lon: 50.19333, zoom: 13, area: 541400000 },
  { id: 15, name: 'Челябинск', lat: 55.159897, lon: 61.402554, zoom: 13, area: 530000000 },
  { id: 16, name: 'Уфа', lat: 54.735147, lon: 55.958727, zoom: 13, area: 707900000 },
];

module.exports = cities;
